module.exports = __webpack_public_path__ + "static/media/collection.17dfa224.png";